import { combineReducers } from 'redux';

import type { DashboardState } from '.';
import { filterReducer } from './filter/filter.reducer';
import { orderedTilesReducer } from './orderedTiles/orderedTiles.reducer';
import { reloadedTilesReducer } from './reloadedTiles/reloadedTiles.reducer';
import { tilesReducer } from './tiles/tiles.reducer';

export const dashboardReducer = combineReducers<DashboardState>({
  tiles: tilesReducer,
  filter: filterReducer,
  orderedTiles: orderedTilesReducer,
  reloaded: reloadedTilesReducer,
});
